module.exports = __webpack_public_path__ + "static/media/comdlg32_531.22fadb5d.ico";